import { Fragment, useState } from "react";
import { Tooltip } from "@mui/material";

import MuiTable from "../../../components/MuiTable";
import { toInternationalFormat } from "../../../utils";
import { brandDetailsObject } from "../../brand components/brand details components/brandDetailObject";
import BrandDetailsDialog from "../brand details components/BrandDetailsDialog";

export default function Connections({ formikProps, connections }) {
  const [brandDetails, setBrandDetails] = useState({
    data: brandDetailsObject,
    state: false,
  });

  var columns = [
    { name: "partner", label: "Partner" },
    {
      name: "monthly_active_user",
      label: "MAU",
    },

    {
      name: "languages",
      label: "Languages",
    },

    {
      name: "locations",
      label: "Location",
    },

    {
      name: "category",
      label: "Category",
    },

    { name: "expected", label: "Expected User Count" },
    { name: "final", label: "Final User Count" },
  ];

  const renderCell = (col, value, row, rowIndex) => {
    if (col.name === "partner") {
      return rowIndex + 1;
    }

    if (col.name === "category") {
      return value.length <= 3 ? (
        value.map((val) => val).join(" ,")
      ) : (
        <div style={{ cusror: "pointer" }}>
          <Tooltip title={value.slice(3, value.length - 1).join(" ,")}>
            {value.slice(0, 3).join(" ,") + `+${value.length - 1 - 3}`}
          </Tooltip>
        </div>
      );
    }

    if (col.name === "languages") {
      return value.length <= 3 ? (
        value.map((val) => val).join(" ,")
      ) : (
        <div style={{ cusror: "pointer" }}>
          <Tooltip title={value.slice(3, value.length - 1).join(" ,")}>
            {value.slice(0, 3).join(" ,") + `+${value.length - 1 - 3}`}
          </Tooltip>
        </div>
      );
    }

    if (col.name === "locations") {
      return value.length <= 3 ? (
        value.map((val) => val).join(" ,")
      ) : (
        <div style={{ cusror: "pointer" }}>
          <Tooltip title={value.slice(3, value.length - 1).join(" ,")}>
            {value.slice(0, 3).join(" ,") + `+${value.length - 1 - 3}`}
          </Tooltip>
        </div>
      );
    }

    if (col.name === "expected") {
      return toInternationalFormat(row.usersCount);
    }

    if (col.name === "final") {
      return formikProps.values.status === "ACTIVE"
        ? "N.A"
        : toInternationalFormat(row.usersCount);
    }
    return value; // default
  };

  return (
    <Fragment>
      <MuiTable columns={columns} data={connections} renderCell={renderCell} />
      <BrandDetailsDialog details={brandDetails} setDetails={setBrandDetails} />
    </Fragment>
  );
}
